<div class="flex bg-bgCard text-white h-full flex-col w-full px-5 p-3">
  <div class="flex m-2 items-center">
    <div (appClickableDirective)="back()" class="cursor-pointer">
      <app-chevron-left-icon class="mr-1 text-white" />Back
    </div>
  </div>
  <div class="bg-dark-primary flexBetween mt-2 py-4 px-2">
    <div class="flex ml-4">
      @for (item of alertsTypesData; track $index) {
        <div class="flexBetween mr-5">
          <span
            class="mr-1 text-alert-header text-[14px] leading-[16px] font-normal"
            >{{ item.name }}</span
          >
          <span class="font-semibold ml-2">{{ item.value }}</span>
        </div>
      }
    </div>
    <div class="flex justify-around items-center bg">
      <div class="relative cursor-pointer" (appClickableDirective)="toggleFilter()">
        @if (showFilter) {
          <div
            class="absolute h-[300px] w-[550px] bg-dark-variant-7 top-[30px] right-[30px] flex rounded-[8px]"
          >
            <div
              class="flex w-[30%] bg-dark-variant-6 flex-col gap-3 p-2 rounded-tr-[25px] rounded-l-[8px]"
            >
              <div class="span1">
                <span>Date</span>
              </div>
              <div class="span2">
                <span>Alert Type</span>
              </div>
              <div class="span3">
                <span>Model Name</span>
              </div>
              <div class="span4">
                <span>Data Logger SN</span>
              </div>
              <div class="span5">
                <span>Customer Details</span>
              </div>
            </div>
            <div
              class="flex w-[70%] bg-transparent flex-col p-2 gap-3"
              (appClickableDirective)="$event.stopPropagation()"
            >
              <div class="flex">
                <input type="date" name="X" id="" />
                <span>to</span>
                <input type="date" name="X" id="" />
              </div>
              <div class="flex justify-between w-[75%]">
                <div class="flexBetween flex-wrap p-1 bg-bgSelect rounded-full">
                  <select
                    name="cars"
                    id=""
                    class="w-[144px] bg-bgSelect border-none text-white"
                    (change)="$event.stopPropagation()"
                  >
                    <option value="volvo">Volvo</option>
                    <option value="saab">Saab</option>
                    <option value="mercedes">Mercedes</option>
                    <option value="audi">Audi</option>
                  </select>
                </div>
                <div
                  class="flexBetween flex-wrap p-1 bg-bgSelect rounded-full ml-3"
                >
                  <select
                    name="cars"
                    id=""
                    class="w-[144px] bg-bgSelect border-none text-white"
                  >
                    <option value="volvo">Volvo</option>
                    <option value="saab">Saab</option>
                    <option value="mercedes">Mercedes</option>
                    <option value="audi">Audi</option>
                  </select>
                </div>
              </div>
              <div class="flex">
                <div class="flexBetween flex-wrap p-1 bg-bgSelect rounded-full">
                  <select
                    name="cars"
                    id=""
                    class="w-[144px] bg-bgSelect border-none text-white"
                  >
                    <option value="volvo">Volvo</option>
                    <option value="saab">Saab</option>
                    <option value="mercedes">Mercedes</option>
                    <option value="audi">Audi</option>
                  </select>
                </div>
              </div>
              <div class="flex">
                <div class="flexBetween flex-wrap p-1 bg-bgSelect rounded-full">
                  <select
                    name="cars"
                    id=""
                    class="w-[144px] bg-bgSelect border-none text-white"
                  >
                    <option value="volvo">Volvo</option>
                    <option value="saab">Saab</option>
                    <option value="mercedes">Mercedes</option>
                    <option value="audi">Audi</option>
                  </select>
                </div>
              </div>
              <div class="flex">
                <div class="flexBetween flex-wrap p-1 bg-bgSelect rounded-full">
                  <select
                    name="cars"
                    id=""
                    class="w-[144px] bg-bgSelect border-none text-white"
                  >
                    <option value="volvo">Volvo</option>
                    <option value="saab">Saab</option>
                    <option value="mercedes">Mercedes</option>
                    <option value="audi">Audi</option>
                  </select>
                </div>
              </div>
              <div class="flex">
                <button>confirm</button>
                <button class="ml-4">clear</button>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  <div
    class="text-white h-full w-full max-w-full grid flex-grow overflow-x-auto overflow-y-auto"
  >
    <div class="table-container w-full overflow-y-auto overflow-x-auto">
      <table class="w-full table-auto">
        <thead class="bg-btTh">
          <tr>
            @for (item of alertHeaders; track $index) {
              <th
                scope=""
                class="p-2 font-medium leading-[14px] text-[12px] text-nowrap"
              >
                {{ item }}
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (item of alertsData; track $index) {
            <tr class="text-center w-full">
              @if (item.plantName) {
                <td class="text-center text-xs whitespace-nowrap">
                  {{ item.plantName }}
                </td>
              }
              @if (item.alerts) {
                <td class="text-center text-xs whitespace-nowrap">
                  {{ item.alerts }}
                </td>
              }
              @if (item.type) {
                <td class="text-center text-xs whitespace-nowrap">
                  {{ item.type }}
                </td>
              }

              @if (item.modelName) {
                <td class="text-center text-xs whitespace-nowrap">
                  {{ item.modelName }}
                </td>
              }
              @if (item.dataLoggerSN) {
                <td class="text-center text-xs whitespace-nowrap">
                  {{ item.dataLoggerSN }}
                </td>
              }

              @if (item.occurred) {
                <td class="text-center text-xs whitespace-nowrap">
                  {{ item.occurred }}
                </td>
              }
              @if (item.resolved) {
                <td class="text-center text-xs whitespace-nowrap">
                  {{ item.resolved }}
                </td>
              }
              @if (item.customerDetailsResponse) {
                <td class="text-center text-xs whitespace-nowrap">
                  <div class="flex flex-col">
                    <span class="text-xs">{{
                      item.customerDetailsResponse.name
                    }}</span>
                    <span class="text-xs">{{
                      item.customerDetailsResponse.email
                    }}</span>
                  </div>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
